import React from 'react';
import { useNavigate } from 'react-router-dom';

function OpenAccount() {
    const navigate = useNavigate(); // Hook to programmatically navigate

    const handleSignupClick = () => {
        navigate('/signup'); // Navigate to the Signup page
    };
    return ( 
        <div className='container p-5 mb-5'>
        <div className='row text-center'>
            <h1 className='mt-5'>Open a Stock Trading account</h1>
            <p>Modern platforms and apps, Rs0 investments, and flat Rs20 intraday and F&O trades. </p>
            <button className='p-2 btn btn-primary fs-5 mb-5'
             style={{width:"20%", margin:"0 auto"}}
             onClick={handleSignupClick} // Attach the click handler
             >Sign up Now</button>   
        </div>
    </div>
     );
}

export default OpenAccount;



